<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-w-full">
            <h2>Obrigado!</h2>
            <h3>Será contactado brevemente.</h3>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    padding: 10px 0 32px 0;
    background-color: #fff;
    @screen lg {
        margin-left: auto;
        padding: 19px 0 39px 0;
        max-width: 380px;
        height: 566px;
    }
    h2 {
        color: $main_color;
        font-weight: 700;
        font-size: 26px;
        line-height: 39px;
        @screen lg {
            padding-top: 207px;
            font-size: 36px;
        }
    }
    h3 {
        color: $main_color;
        font-size: 16px;
        @screen lg {
            margin-bottom: 11px;
            font-size: 20px;
        }
    }
}

</style>
